import React from 'react'
import {Card, CardBody, CardHeader, Col, Row} from 'reactstrap';
import {Button} from 'semantic-ui-react'
import {MDBDataTable} from 'mdbreact'
import * as common from '../../../const/Common/CommonFunc';
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import axiosTags from "../../../axios/axios_tag";
import {Empty} from "antd";
import {DatePicker} from "antd";
import moment from "moment";
import '../../../react-antd.css'
import $ from "jquery";
import Download from '../../../components/Button/DownloadbleButton'

const {RangePicker} = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class App extends React.Component {

  state = {
    totalhandled: "",
    isTotal: false,
    visitors_list: [],
    spin: true,
    corporate_id: "",
    details: [],
    start_date: '',
    end_date: '',
    checkoutColumns: [
      {
        label: 'Date',
        field: 'date',
        sort: 'asc'
      },
      {
        label: 'Receptionist Name',
        field: 'receptionistName',
        sort: 'asc',
        footer: 'Total: '
      },
      {
        label: 'Number of visitors handled',
        field: 'NumberofVisitorsHandled',
        sort: 'asc',

      },
      {
        label: 'Time taken per visitor',
        field: 'timeTakenPerVisitor',
        sort: 'asc',

      }
    ]
  };

  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {
    } else {
      let start = new Date(dateString[0]).getTime();
      let end = new Date(dateString[1]).getTime();
      this.setState({
        start_date: start,
        end_date: end,
      });

      if(this.props.usr_obj.userRoles !== "SYS_ADMIN" ){
        this.buttonHandler(start,end);
      }
    }
  };

  getAllDetails = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(`corporate/services`, {headers: headers})
      .then(response => {
        if (response.data.success) {
          if(response.data.body.length !== 0){
            this.setState({
              corporate_id: response.data.body[0].corporateId,
              details: response.data.body,
            });
            this.buttonHandler();
          }
        } else {
          this.setState({
            details: [],
            spin: false
          });
          this.props.spinnerHandler(false);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDetails();
        }else{
          this.props.spinnerHandler(false);
        }
      });
  };
  corporateHandler = name => (e, {value}) => {
    this.setState({
      [name]: value
    });
  };

  buttonHandler = (start,end) => {

    let {corporate_id, start_date, end_date} = this.state;
    let condition = false;
    let startDate = new Date().setDate(new Date().getDate() - 30);
    let endDate = new Date().setDate(new Date().getDate());

    if(start === undefined && end === undefined){
      if (start_date !== "" && end_date !== "") {
        startDate = start_date;
        endDate = end_date;
      }
    }else{
      startDate = start;
      endDate = end;
    }

    if(this.props.usr_obj.userRoles !== "SYS_ADMIN"){
      corporate_id = this.props.usr_obj.corporates[0].corporateId
    }

    corporate_id === '' ? common.notifyMessage("Please select corporate") : condition = true;

    if (condition) {
      this.setState({
        spin: true
      });

      this.props.spinnerHandler(true);

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };
      axios.get(`report/corporate/` + corporate_id + `/summaryreportofreceptionist?startDate=` + startDate + `&endDate=` + endDate, {headers: headers})
        .then(async response => {

          if (response.data.success) {
            this.setState({
              totalhandled: response.data.content.totalVisitors,
              isTotal: true,
              visitors_list: response.data.content.records,
            });
          }else{
            this.setState({
              totalhandled:0,
              isTotal: true,
              visitors_list: []
            });
          }
        })

        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.buttonHandler(start, end);
          } else {
            this.props.spinnerHandler(false)
          }
        })

        .finally(fin => {
          this.props.spinnerHandler(false);
        });
    }
  };

  componentDidMount() {
    if(this.props.usr_obj.userRoles === "SYS_ADMIN"){
      this.getAllDetails();
    }else{
      this.buttonHandler();
    }
  }

  render() {
    let rows = [];
    let corporate_options = [];
    if (this.state.details.length !== 0) {
      this.state.details.map((details, index) => {
        const obj = {
          key: details.corporateId,
          text: details.corporateName,
          value: details.corporateId
        };
        corporate_options.push(obj)
      })
    }
    if (this.state.visitors_list.length !== 0) {
      this.state.visitors_list.map((value, index) => {
        rows.push(
          {

            date: value.date,
            receptionistName: value.reseptionistName,
            NumberofVisitorsHandled: value.visitorCount,
            timeTakenPerVisitor: value.timePerVisitor

          }
        )
      });
    }

    let columns = this.state.checkoutColumns;
    let data = {columns, rows};
    return (

      <div>
        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <Card>
              <CardHeader>
                Search Details
              </CardHeader>

              <CardBody className=" paddingBottom">
                <div className="form-group paddingBottom">
                  <Row>
                    {
                      this.props.usr_obj.userRoles === "SYS_ADMIN" ?
                        <Col xs={5}>
                          <LabelDropdown
                            disabled={this.state.spin}
                            tagText={"Corporates"}
                            placeholder={"Select Corporate"}
                            options={corporate_options}
                            value={this.state.corporate_id}
                            onChange={this.corporateHandler("corporate_id")}
                          />
                        </Col>:null
                    }
                    <Col xs={4}>
                      <RangePicker
                        className={"rangepicker-super-meeting-report_"}
                        size={"mini"}
                        defaultValue={[moment().subtract(30, "days"), moment().subtract(0, "days")]}
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        onChange={this.onChange}
                      />
                    </Col>
                    {
                      this.props.usr_obj.userRoles === "SYS_ADMIN" ?
                        <Col>
                          <Button.Group className={"dual-btn-rangepicker-corp-sms-report"}>
                            <Button positive onClick={()=>this.buttonHandler()}>Search</Button>
                          </Button.Group>
                        </Col>:null
                    }
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Card className="card margin0">
              <CardHeader>
               Receptionist Summary Report History
                <Download data={this.state.visitors_list} userType={"LOGIN_HISTORY"}/>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg="12">
                    {
                      this.state.visitors_list.length !== 0 ?
                        <MDBDataTable
                          id={"history-table"}
                          responsive
                          responsiveSm
                          responsiveMd
                          responsiveLg
                          responsiveXl
                          bordered
                          hover
                          data={data}/>
                        :
                        <div className={"align-center fully-width"}>
                          <Empty description={"Records not found"} className={"empty-icon"}/>
                          <br/>
                        </div>
                    }

                    {
                      this.state.isTotal ?
                        <div style={{marginLeft: "62.5vw"}}>
                          <tr style={{margin: "0", padding: "0", verticalAlign: "baseline", boxSizing: "border-box"}}>
                            <td style={{
                              width: "16vw",
                              height: "6vh",
                              border: "1px solid #dee2e6",
                              padding: "0",
                              verticalAlign: "center",
                              textAlign: "center",
                              fontWeight: "normal",
                              boxSizing: "border-box",
                              font: "inherit",
                              fontSize: "18px",
                              background: "#cbeecb"
                            }}>{"Total Visitors : " + this.state.totalhandled.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                          </tr>
                        </div>
                        : null
                    }
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  visitors: state.viewAllCheckIN.visitors,
  checkInVisitors: state.viewAllCheckIN.checkInVisitors,
  historyColumns: state.viewAllCheckIN.historyColumns,
  column: state.viewAllCheckIN.column,

  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
